// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1dJmz","file":"styles_file__3-bjy"};